export const CREATE_IMMUNISATION = "CREATE_IMMUNISATION";
export const CREATE_IMMUNISATIONS = "CREATE_IMMUNISATIONS";
export const SAVE_IMMUNISATION = "SAVE_IMMUNISATION";
export const LOAD_IMMUNISATIONS = "LOAD_IMMUNISATIONS";
export const LOAD_IMMUNISATION = "LOAD_IMMUNISATION";
export const DELETE_IMMUNISATION = "DELETE_IMMUNISATION";
export const CREATE_IMMUNISATION_SUCCESS = "CREATE_IMMUNISATION_SUCCESS";
export const SAVE_IMMUNISATION_SUCCESS = "SAVE_IMMUNISATION_SUCCESS";
export const LOAD_IMMUNISATIONS_SUCCESS = "LOAD_IMMUNISATIONS_SUCCESS";
export const LOAD_IMMUNISATION_SUCCESS = "LOAD_IMMUNISATION_SUCCESS";
export const DELETE_IMMUNISATION_SUCCESS = "DELETE_IMMUNISATION_SUCCESS";
export const SEND_IMMUNISATIONS_HISTORY = "SEND_IMMUNISATIONS_HISTORY";
